<mat-tab-group [@.disabled]="true" [selectedIndex]="selectedTabIndex">
  <mat-tab label="Open">
    <div *ngIf="openStatementsState$ | async as state">
      <div *ngIf="state.data?.length && !state.loading && !state.error" class="overflow-x-auto w-full">
        <table mat-table class="w-full min-w-[720px]" [dataSource]="state.data">
          <!-- Month Column -->
          <ng-container matColumnDef="month">
            <th mat-header-cell *matHeaderCellDef>Period</th>
            <td mat-cell *matCellDef="let element">{{ element.startsAt | date: 'MMMM, yyyy' }}</td>
          </ng-container>

          <!-- Type Column -->
          <ng-container matColumnDef="type">
            <th mat-header-cell *matHeaderCellDef>Type</th>
            <td mat-cell *matCellDef="let element">
              {{ element.type ? (element.type | humanize) : 'Statement' }}
            </td>
          </ng-container>

          <!-- Owners Column -->
          <ng-container matColumnDef="owner">
            <th mat-header-cell *matHeaderCellDef>Owner</th>
            <td mat-cell *matCellDef="let element">
              <ng-container *ngIf="element.property?.owners[0] as owner">
                <div>
                  {{ owner.type === 'individual' ? owner.firstName + ' ' + owner.name : owner.name }}
                </div>
                <div class="text-night-lighter">
                  {{ owner.email }}
                </div>
              </ng-container>
            </td>
          </ng-container>

          <!-- Property Column -->
          <ng-container matColumnDef="property">
            <th mat-header-cell *matHeaderCellDef>Property</th>
            <td mat-cell *matCellDef="let element">
              <div class="flex items-center">
                <img [src]="element.property.picture" alt="Property Image" class="w-8 h-6 rounded mr-2" />
                <sbnb-truncate class="max-w-[300px]" [text]="element.property.name"></sbnb-truncate>
              </div>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr
            class="hover:bg-smoke-lighter cursor-pointer"
            mat-row
            *matRowDef="let row; columns: displayedColumns"
            [routerLink]="[statementsDashboardUrl, row.id]"></tr>
        </table>
      </div>

      <div
        *ngIf="!state.loading && !state.error && state.data.length === 0"
        class="border rounded border-smoke p-4 text-center mt-4 text-sm">
        No open statements available
      </div>

      <sbnb-loading-spinner *ngIf="state.loading"></sbnb-loading-spinner>

      <div class="error" *ngIf="state.error">{{ state.error }}</div>
    </div>
  </mat-tab>

  <mat-tab label="In Review">
    <div *ngIf="inReviewStatementsState$ | async as state">
      <div *ngIf="state.data?.length && !state.loading && !state.error" class="overflow-x-auto w-full">
        <table mat-table class="w-full min-w-[720px]" [dataSource]="state.data">
          <!-- Month Column -->
          <ng-container matColumnDef="month">
            <th mat-header-cell *matHeaderCellDef>Period</th>
            <td mat-cell *matCellDef="let element">{{ element.startsAt | date: 'MMMM, yyyy' }}</td>
          </ng-container>

          <!-- Type Column -->
          <ng-container matColumnDef="type">
            <th mat-header-cell *matHeaderCellDef>Type</th>
            <td mat-cell *matCellDef="let element">
              {{ element.type ? (element.type | humanize) : 'Statement' }}
            </td>
          </ng-container>

          <!-- Owners Column -->
          <ng-container matColumnDef="owner">
            <th mat-header-cell *matHeaderCellDef>Owner</th>
            <td mat-cell *matCellDef="let element">
              <ng-container *ngIf="element.property?.owners[0] as owner">
                <div>
                  {{ owner.type === 'individual' ? owner.firstName + ' ' + owner.name : owner.name }}
                </div>
                <div class="text-night-lighter">
                  {{ owner.email }}
                </div>
              </ng-container>
            </td>
          </ng-container>

          <!-- Property Column -->
          <ng-container matColumnDef="property">
            <th mat-header-cell *matHeaderCellDef>Property</th>
            <td mat-cell *matCellDef="let element">
              <div class="flex items-center">
                <img [src]="element.property.picture" alt="Property Image" class="w-8 h-6 rounded mr-2" />
                <sbnb-truncate class="max-w-[300px]" [text]="element.property.name"></sbnb-truncate>
              </div>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr
            class="hover:bg-smoke-lighter cursor-pointer"
            mat-row
            *matRowDef="let row; columns: displayedColumns"
            [routerLink]="[statementsDashboardUrl, row.id]"></tr>
        </table>
      </div>

      <div
        *ngIf="!state.loading && !state.error && state.data.length === 0"
        class="border rounded border-smoke p-4 text-center mt-4 text-sm">
        No in review statements available
      </div>

      <sbnb-loading-spinner *ngIf="state.loading"></sbnb-loading-spinner>

      <div class="error" *ngIf="state.error">{{ state.error }}</div>
    </div>
  </mat-tab>

  <mat-tab label="Published">
    <div *ngIf="closedStatementsState$ | async as state">
      <div *ngIf="state.data?.length && !state.loading && !state.error" class="overflow-x-auto w-full">
        <table mat-table class="w-full min-w-[720px]" [dataSource]="state.data">
          <!-- Month Column -->
          <ng-container matColumnDef="month">
            <th mat-header-cell *matHeaderCellDef>Period</th>
            <td mat-cell *matCellDef="let element">{{ element.startsAt | date: 'MMMM, yyyy' }}</td>
          </ng-container>

          <!-- Type Column -->
          <ng-container matColumnDef="type">
            <th mat-header-cell *matHeaderCellDef>Type</th>
            <td mat-cell *matCellDef="let element">
              {{ element.type ? (element.type | humanize) : 'Statement' }}
            </td>
          </ng-container>

          <!-- Owners Column -->
          <ng-container matColumnDef="owner">
            <th mat-header-cell *matHeaderCellDef>Owner</th>
            <td mat-cell *matCellDef="let element">
              <ng-container *ngIf="element.property?.owners[0] as owner">
                <div>
                  {{ owner.type === 'individual' ? owner.firstName + ' ' + owner.name : owner.name }}
                </div>
                <div
                  class="text-night-lighter cursor-pointer"
                  matTooltip="Click to copy"
                  [matTooltipPosition]="'before'">
                  {{ owner.email }}
                </div>
              </ng-container>
            </td>
          </ng-container>

          <!-- Property Column -->
          <ng-container matColumnDef="property">
            <th mat-header-cell *matHeaderCellDef>Property</th>
            <td mat-cell *matCellDef="let element">
              <div class="flex items-center">
                <img [src]="element.property.picture" alt="Property Image" class="w-8 h-6 rounded mr-2" />
                <sbnb-truncate class="max-w-[300px]" [text]="element.property.name"></sbnb-truncate>
              </div>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr
            class="hover:bg-smoke-lighter cursor-pointer"
            mat-row
            *matRowDef="let row; columns: displayedColumns"
            [routerLink]="[statementsDashboardUrl, row.id]"></tr>
        </table>
      </div>

      <div
        *ngIf="!state.loading && !state.error && state.data.length === 0"
        class="border rounded border-smoke p-4 text-center mt-4 text-sm">
        No closed statements available
      </div>

      <sbnb-loading-spinner *ngIf="state.loading"></sbnb-loading-spinner>

      <div class="error" *ngIf="state.error">{{ state.error }}</div>
    </div>
  </mat-tab>

  <mat-tab *ngIf="statementsPaidHandlingEnabled$ | async" label="Paid">
    <div *ngIf="paidStatementsState$ | async as state">
      <div *ngIf="state.data?.length && !state.loading && !state.error" class="overflow-x-auto w-full">
        <table mat-table class="w-full min-w-[720px]" [dataSource]="state.data">
          <!-- Month Column -->
          <ng-container matColumnDef="month">
            <th mat-header-cell *matHeaderCellDef>Period</th>
            <td mat-cell *matCellDef="let element">{{ element.startsAt | date: 'MMMM, yyyy' }}</td>
          </ng-container>

          <!-- Type Column -->
          <ng-container matColumnDef="type">
            <th mat-header-cell *matHeaderCellDef>Type</th>
            <td mat-cell *matCellDef="let element">
              {{ element.type ? (element.type | humanize) : 'Statement' }}
            </td>
          </ng-container>

          <!-- Owners Column -->
          <ng-container matColumnDef="owner">
            <th mat-header-cell *matHeaderCellDef>Owner</th>
            <td mat-cell *matCellDef="let element">
              <ng-container *ngIf="element.property?.owners[0] as owner">
                <div>
                  {{ owner.type === 'individual' ? owner.firstName + ' ' + owner.name : owner.name }}
                </div>
                <div
                  class="text-night-lighter cursor-pointer"
                  matTooltip="Click to copy"
                  [matTooltipPosition]="'before'">
                  {{ owner.email }}
                </div>
              </ng-container>
            </td>
          </ng-container>

          <!-- Property Column -->
          <ng-container matColumnDef="property">
            <th mat-header-cell *matHeaderCellDef>Property</th>
            <td mat-cell *matCellDef="let element">
              <div class="flex items-center">
                <img [src]="element.property.picture" alt="Property Image" class="w-8 h-6 rounded mr-2" />
                <sbnb-truncate class="max-w-[300px]" [text]="element.property.name"></sbnb-truncate>
              </div>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr
            class="hover:bg-smoke-lighter cursor-pointer"
            mat-row
            *matRowDef="let row; columns: displayedColumns"
            [routerLink]="[statementsDashboardUrl, row.id]"></tr>
        </table>
      </div>

      <div
        *ngIf="!state.loading && !state.error && state.data.length === 0"
        class="border rounded border-smoke p-4 text-center mt-4 text-sm">
        No closed statements available
      </div>

      <sbnb-loading-spinner *ngIf="state.loading"></sbnb-loading-spinner>

      <div class="error" *ngIf="state.error">{{ state.error }}</div>
    </div>
  </mat-tab>
</mat-tab-group>
